import { render, staticRenderFns } from "./DetalheOrcamento.vue?vue&type=template&id=4fff2923&"
import script from "./DetalheOrcamento.vue?vue&type=script&lang=js&"
export * from "./DetalheOrcamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports